import React from 'react';
import Layout from '../layout';
import CareersSectionOne from '../components/Esper/Careers/CareersSectionOne';
import CareersSectionTwo from '../components/Esper/Careers/CareersSectionTwo';
import CareersSectionFour from '../components/Esper/Careers/CareersSectionFour';
import CareersOptions from '../components/Esper/Careers/CareersOptions';
import Hero from '../assets/v2/group-168.svg';
import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    ogImage={Hero}
    messages={messages}
    title={`Careers @ Esper`}
    description={`Esper is hiring Android devs & EMM/MDM talent in Bangalore & Seattle! Discover open jobs at Esper, the most powerful cloud platform for Android DevOps. `}
    keywords={`Esper Careers, careers at esper`}
    className="first-page"
    location={props.location}
  >
    <CareersSectionOne />
    <CareersSectionTwo />
    <CareersSectionFour />
    <CareersOptions />
  </Layout>
);
